import React, { useState, useEffect, useRef } from 'react';
import { SyncOutlined, ExclamationCircleOutlined, CheckCircleOutlined, StopOutlined } from '@ant-design/icons';

const SyncStatusIndicator = () => {
    const [syncStatus, setSyncStatus] = useState({
        isVisible: false,
        message: '',
        isComplete: false
    });
    const hideTimeout = useRef(null);

    useEffect(() => {
        const handleSyncStatus = (event) => {
            const { message, isComplete } = event.detail;

            // Cancelar timeout anterior si existe
            if (hideTimeout.current) {
                clearTimeout(hideTimeout.current);
                hideTimeout.current = null;
            }

            // Detectar si es error o cancelación
            const isError = message.toLowerCase().includes('error');
            const isCanceled = message.toLowerCase().includes('cancelada');

            // Si es evento de cierre (completado, error o cancelación)
            if (isComplete || isError || isCanceled) {
                setSyncStatus({
                    isVisible: true,
                    message,
                    isComplete: true
                });

                hideTimeout.current = setTimeout(() => {
                    setSyncStatus({ isVisible: false, message: '', isComplete: false });
                    hideTimeout.current = null;
                }, 5000);

                return;
            }

            // Caso normal: sincronización en curso
            setSyncStatus({
                isVisible: true,
                message,
                isComplete: false
            });
        };

        window.addEventListener('syncStatus', handleSyncStatus);
        return () => {
            window.removeEventListener('syncStatus', handleSyncStatus);
            if (hideTimeout.current) clearTimeout(hideTimeout.current);
        };
    }, []);

    if (!syncStatus.isVisible) return null;

    // Clasificación visual
    const isError = syncStatus.message.toLowerCase().includes('error');
    const isCanceled = syncStatus.message.toLowerCase().includes('cancelada');
    const isRetrying = syncStatus.message.toLowerCase().includes('reintentando');
    const isCompleted = syncStatus.isComplete && !isError && !isCanceled;

    const getBackgroundColor = () => {
        if (isError) return '#ff4d4f';     
        if (isCanceled) return '#d46b08';  
        if (isCompleted) return '#52c41a'; 
        if (isRetrying) return '#faad14'; 
        return '#1677ff';                 
    };

    const getIcon = () => {
        if (isError) return <ExclamationCircleOutlined style={{ fontSize: '14px' }} />;
        if (isCanceled) return <StopOutlined style={{ fontSize: '14px' }} />;
        if (isCompleted) return <CheckCircleOutlined style={{ fontSize: '14px' }} />;
        return <SyncOutlined spin style={{ fontSize: '14px' }} />;
    };

    return (
        <div
            style={{
                position: 'fixed',
                bottom: '20px',
                left: '20px',
                backgroundColor: getBackgroundColor(),
                color: 'white',
                padding: '10px 16px',
                borderRadius: '8px',
                fontSize: '13px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                zIndex: 1001,
                boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                maxWidth: '400px',
                minWidth: '200px',
                wordBreak: 'break-word',
                animation: 'slideIn 0.3s ease-out',
                border: isError ? '1px solid #d9534f' : 'none'
            }}
        >
            {getIcon()}
            <span style={{ lineHeight: '1.4' }}>{syncStatus.message}</span>
        </div>
    );
};

export default SyncStatusIndicator;